import api from "../../api";

export const getProfile = async (data : { id : string | null}) => {

    const res = await api.get(`member/${(data.id == null) ? "myprofile" : data.id}/`)
    return res.data
}

export const getProfilePosts = async ({id,data} : { id : string | null, data : {
    page : number,
    page_size : number,
}}) => {

    const res = await api.get(`post/${(id == null) ? "myposts/" : `?member_id=${id}`}`, { params : data })
    return res.data
}

export const getProfileReviews = async (data : { id : string | null}) => {

    const res = await api.get(`coach/${data.id}/reviews/`)
    return res.data
}

export const postProfileReview = async ( { id , data } : {
    id : string,
    data : {
        ranking : number,
        comment : string,
    }
}) => {
    const res = await api.post(`coach/${id}/reviews/`, data)
    return res.data
}

export const postMemberReport = async ({ id , data } : { id : string, data : {
    category : string,
}}) => {
    const res = await api.post(`member/${id}/report/`, data)
    return res.data
}

export const postFollow = async (data : { id : string , notificationId ?: string}) => {

    delete data.notificationId

    const res = await api.post(`member/${data.id}/follow/`)
    return res.data
}

export const deleteFollow = async ({ id } : { id : string }) => {
    const res = await api.delete(`member/${id}/follow/`)
    return res.data
}

export const blockUser = async ({ id } : { id : string }) => {
    const res = await api.post(`member/${id}/block/`)
    return res.data
}

export const unblockUser = async ({ id } : { id : string }) => {
    const res = await api.delete(`member/${id}/block/`)
    return res.data
}

export const getClasses = async ( data : { coach : string }) => {

    const res = await api.get(`packages/`, { params : data })
    return res.data
}

export const getClassDetail = async ( data : { id : string ,
    coach ?: string,
}) => {
    
        const res = await api.get(`packages/${data.id}/`, { params : {
            coach : data.coach
        }})

        return res.data
}

export const postClassPurchase = async ( { id , data } : { id : string , data : {
    coach : string | null,
    endpoint : string,
}}) => {
        
    const res = await api.post(`packages/${id}/`, data)
    return res.data
}

export const getPackages = async ( data : { 
    type : string,
    duration : string,
    coach : string | null,
}) => {

    
    const res = await api.get(`packages/`, { params : data })
    return res.data
}

export const getCoachAvailability = async ( data : { id : string }) => {
    
    const res = await api.get(`private_classes/credits/${data.id}/slots/`)
    return res.data
}

export const putBooking = async ( { id , data } : { id : string , data : {
    start_time : string,
}}) => {
    const res = await api.put(`private_classes/credits/${id}/book/`, data)
    return res.data
}

export const getHealthEvents = async (data : {
    has_healthkit_data ?: boolean,
    page ?: string,
    page_size ?: number,
}) => {

    const res = await api.get(`events/healthkit/`, { params : data })
    return res.data
}

export const putHealthEvents = async (data : {
    id : string,
    data : any,
}) => {

    const res = await api.put(`events/healthkit/${data.id}/`, data.data)
    return res.data
}

export const getHealthStats = async (data : {
    interval : string,
    user_id ?: string,
    offset : number,
}) => {

    const res = await api.get(`events/healthkit/stats/`, { params : data })
    return res.data
}

export const putActivitySharing = async (data : {
    activity_data_shared : boolean,
}) => {
    const res = await api.put(`member/myprofile/activity_sharing/`, data)
    return res.data
}

export const getFollowers = async (data : { id : string | null }) => {
    const res = await api.get(`member/${(data.id == null) ? "myprofile" : data.id}/followers/`)
    return res.data
}

export const getFollowing = async (data : { id : string | null }) => {
    const res = await api.get(`member/${(data.id == null) ? "myprofile" : data.id}/following/`)
    return res.data
}